// src/adminFlow/useAutoRefresh.js
import { useEffect } from 'react';

/**
 * Triggers fn() on an interval and when window becomes visible/focused.
 * @param {Function} fn  - your fetch/reload function
 * @param {Object} opts  - { intervalMs?: number, refetchOnFocus?: boolean }
 */
export default function useAutoRefresh(
  fn,
  { intervalMs = 30000, refetchOnFocus = true } = {}
) {
  useEffect(() => {
    let t;
    if (intervalMs) t = setInterval(() => fn?.(), intervalMs);

    function onFocus() {
      if (refetchOnFocus && document.visibilityState === 'visible') fn?.();
    }
    function onVisChange() {
      if (refetchOnFocus && document.visibilityState === 'visible') fn?.();
    }

    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisChange);

    return () => {
      if (t) clearInterval(t);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisChange);
    };
  }, [fn, intervalMs, refetchOnFocus]);
}
